import React from 'react';
import PropTypes from 'prop-types';
import NetSales from '../../components/NetSales';
import SoldTopList from '../../components/SoldTopList';
import TotalCollected from '../../components/TotalCollected';
import TotalSalesBreakdown from '../TotalSalesBreakdown';
import BrandFilter from '../../filters/BrandFilterContainer';
import SalesByProductFilters from '../containers/SalesByProductFilters';
import BarberFilter from '../../metrics/barberFilterContainer';
import Layout from '../../components/Layout';
import TopGrossingProducts from '../../components/TopGrossingProducts';
import DirtyFilterOverlay from '../../components/DirtyFilterOverlay';
import CollectedByPaymentList from '../../components/CollectedByPaymentList';
import { RoleAwareShop, RoleDenyBrand, RoleAllowBrand } from '../../../../auth/roleAware';
import ShopFilter from '../../filters/ShopFilter';
import { taxBreakdownArray } from '../../shapes';

const SalesByProduct = ({
  discounts,
  fees,
  grossSales,
  refunds,
  taxes,
  tips,
  totalCollected,
  data,
  products,
  netSales,
  loanRepayment,
  grossProfit,
  supplyPrice,
  productSales,
  taxBreakdown,
}) => (
  <Layout title="Sales by Product">
    <div className="c-sales-by-product-wrapper">
      <div className="c-report-filters">
        <div className="u-mr0 large-and-up-mr- u-mb">
          <SalesByProductFilters
            showCsvExport
            csvJobName="product-report"
            csvModalTitle="Sales by Product"
            disableBarberFilter
          >
            <RoleAllowBrand>
              <ShopFilter />
            </RoleAllowBrand>
            <RoleDenyBrand>
              <RoleAwareShop>
                <div className="c-report-filters__item">
                  <BarberFilter />
                </div>
              </RoleAwareShop>
            </RoleDenyBrand>
            <RoleDenyBrand>
              <div className="c-report-filters__item">
                <BrandFilter />
              </div>
            </RoleDenyBrand>
          </SalesByProductFilters>
        </div>
      </div>
      <div className="u-position-relative">
        <DirtyFilterOverlay style={{ left: '-20px' }} />
        <div className="layout u-pt+">
          <div className="layout__item u-2/4-extralarge-and-up">
            <TopGrossingProducts data={data} />
          </div>
          <div className="layout__item u-1/4-extralarge-and-up small-mt0 extralarge-and-down-mt+">
            <SoldTopList items={products} title="Products sold" />
          </div>
          <div className="layout__item u-1/4-extralarge-and-up small-mt0 extralarge-and-down-mt+">
            <CollectedByPaymentList
              items={productSales}
              includeModalColumns={['type', 'pos', 'cash', 'giftCard']}
              includeModalRows={['net', 'tax', 'fees', 'total']}
            />
          </div>
        </div>
        <div className="c-sales-by-product-grid u-mt extralarge-and-up-mt+">
          <div className="c-sales-by-product-grid__net-sales">
            <NetSales
              kind="product"
              showGrossProfit
              showCostOfInventory
              totalSales={grossSales}
              refunds={refunds}
              discounts={discounts}
              grossProfit={grossProfit}
              netSales={netSales}
              costOfInventory={supplyPrice}
            />
          </div>
          <div className="c-sales-by-product-grid__total-collected">
            <TotalCollected
              showTips={false}
              showGrossProfit
              netSales={netSales}
              fees={fees}
              taxes={taxes}
              tips={tips}
              totalCollected={totalCollected}
              loanRepayment={loanRepayment}
              taxBreakdown={taxBreakdown}
            />
          </div>
        </div>
        <div>
          <TotalSalesBreakdown showCountInTotal totalTitle={'Total Products'} serviceProductTitle={'Products'} />
        </div>
      </div>
    </div>
  </Layout>
);

SalesByProduct.propTypes = {
  discounts: PropTypes.number.isRequired,
  fees: PropTypes.number.isRequired,
  grossSales: PropTypes.number.isRequired,
  refunds: PropTypes.number.isRequired,
  taxes: PropTypes.number.isRequired,
  tips: PropTypes.number.isRequired,
  totalCollected: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(PropTypes.object),
  products: PropTypes.arrayOf(PropTypes.object),
  netSales: PropTypes.number.isRequired,
  loanRepayment: PropTypes.number.isRequired,
  grossProfit: PropTypes.number.isRequired,
  supplyPrice: PropTypes.number.isRequired,
  productSales: PropTypes.object.isRequired,
  taxBreakdown: taxBreakdownArray.isRequired,
};

SalesByProduct.defaultProps = {
  data: {},
  products: {},
};

export default SalesByProduct;
